import { MenuPoint } from '@agilox/ui-common';
import { planMenuPoints } from './menupoints';

export const mobileMenuPoints: MenuPoint[] = [
	planMenuPoints.dashboard,
	{
		name: 'menu.menu',
		url: '',
		icon: 'menu_hamburger',
		roles: [],
		submenus: [
			planMenuPoints.dashboard,
			planMenuPoints.mapEditor,
			planMenuPoints.aiWorkflows,
			planMenuPoints.workflows,
			planMenuPoints.help,
			planMenuPoints.logout,
		],
	},
];
